var _rect, _rect2, _rect3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelegate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 9,
    width: 4,
    height: 4,
    rx: 2,
    transform: "rotate(90 19 9)",
    stroke: "#FC7B52",
    strokeWidth: 1.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 17,
    width: 4,
    height: 4,
    rx: 2,
    transform: "rotate(90 19 17)",
    stroke: "#FC7B52",
    strokeWidth: 1.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 4,
    height: 4,
    rx: 2,
    transform: "rotate(-90 4 7)",
    stroke: "#FC7B52",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H15",
    stroke: "#FC7B52",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7V7C6 8.88562 6 9.82843 6.58579 10.4142C7.17157 11 8.11438 11 10 11H15",
    stroke: "#FC7B52",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegate);
export default __webpack_public_path__ + "static/media/delegate.b671c576609f63042e2eab7268253abf.svg";
export { ForwardRef as ReactComponent };